import { create } from "zustand";
import type { Instance } from "../components/table/types";

interface InstanceState {
  data: Instance[];
  filterData: Instance[];
  selectedIds: Set<string>;
  openDropdown: number | null;
  showSkeleton: boolean;
  page: number;
  limit: number;
  providerType: "aws" | "gcp" | "azure";
  loadingSimilar: boolean;
  setLoadingSimilar: (loading: boolean) => void;
  // actions
  setData: (data: Instance[]) => void;
  setFilterData: (filterData: Instance[]) => void;
  toggleSelectAll: () => void;
  toggleRowSelect: (id: string) => void;
  toggleDropdown: (index: number) => void;
  setShowSkeleton: (val: boolean) => void;
  setProviderType: (providerType: "aws" | "gcp" | "azure") => void;
  setSelectedIds: (ids: Set<string>) => void;
  awsInstances: Instance[];
  gcpInstances: Instance[];
  azureInstances: Instance[];
  loading: boolean;
  error: string | null;
  setAwsInstances: (data: Instance[]) => void;
  setGcpInstances: (data: Instance[]) => void;
  setAzureInstances: (data: Instance[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useInstanceStore = create<InstanceState>((set, get) => ({
  data: [],
  filterData: [],
  selectedIds: new Set(),
  openDropdown: null,
  showSkeleton: true,
  page: 1,
  limit: 10,
  providerType: "aws",
  loadingSimilar: false,
  awsInstances: [],
  gcpInstances: [],
  azureInstances: [],
  loading: false,
  error: null,
  setAwsInstances: (data) => set({ awsInstances: data }),
  setGcpInstances: (data) => set({ gcpInstances: data }),
  setAzureInstances: (data) => set({ azureInstances: data }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  setData: (data) => set({ data }),
  setFilterData: (filterData) => set({ filterData }),
  setShowSkeleton: (val) => set({ showSkeleton: val }),
  setSelectedIds: (ids) => set({ selectedIds: new Set(ids) }),

  setLoadingSimilar: (loading) => set({ loadingSimilar: loading }),

  toggleSelectAll: () => {
    const { data, selectedIds } = get();
    if (selectedIds.size === data.length) {
      set({ selectedIds: new Set() });
    } else {
      set({ selectedIds: new Set(data.map((d) => d.id)) });
    }
  },

  toggleRowSelect: (id: string) => {
    const selectedIds = new Set(get().selectedIds);
    if (selectedIds.has(id)) selectedIds.delete(id);
    else selectedIds.add(id);
    set({ selectedIds });
  },

  toggleDropdown: (index: number) => {
    set({ openDropdown: get().openDropdown === index ? null : index });
  },
  setProviderType: (providerType: "aws" | "gcp" | "azure") =>
    set({ providerType }),
  reset: () =>
    set({
      awsInstances: [],
      gcpInstances: [],
      azureInstances: [],
      loading: false,
      error: null,
    }),
}));
